import React, { useEffect } from "react";
import { useState } from "react";
import { useFormik } from "formik";
import MyAutocomplete from "../../../../../../../components/MyAutocomplete";
import { Grid } from "@mui/material";
import { Box, Button } from "@material-ui/core";
import {
  useGeneratedModelCode,
  useMqXS,
} from "../../../../../../../utils/Utils";
import { useHistory, useParams } from "react-router";
import { useAxios } from "../../../../../../../utils/useAxios";
import { useDispatch, useSelector } from "react-redux";
import { UPDATE_SNACKBAR } from "../../../../../../../store/actions/appActions";

import "./style.css";
import { SET_SCHEDE_TARATURA } from "../../../../../../../store/actions/actions";

const A4VGV40 = ({ data, readOnly }) => {
  const mq_xs = useMqXS();
  const dispatch = useDispatch();
  const params = useParams();
  const history = useHistory();
  const updateSnackbar = (objData) =>
    dispatch({ type: UPDATE_SNACKBAR, value: objData });

  const [initialValues, setInitialValues] = useState(null);
  const validateForm = (values) => {
    const errors = {};

    const get = (path, fallback = undefined) =>
      path.split('.').reduce((acc, part) => (acc && acc[part] !== undefined ? acc[part] : fallback), values);

    const dpa = get("testing_relevant_data.differential_pressure_valve_a");
    const dpb = get("testing_relevant_data.differential_pressure_valve_b");

    const validatePressure = (val) => {
      if (val === null || val === undefined || val === "") return "Required";
      const num = Number(val);
      if (isNaN(num)) return "Must be a number";
      if (num < 300 || num > 530) return "Must be between 300 and 530";
      if (num % 10 !== 0) return "Must be in steps of 10";
      return null;
    };

    const dpaError = validatePressure(dpa);
    const dpbError = validatePressure(dpb);

    if (dpaError) {
      errors.testing_relevant_data = {
        ...(errors.testing_relevant_data || {}),
        differential_pressure_valve_a: dpaError,
      };
    }

    if (dpbError) {
      errors.testing_relevant_data = {
        ...(errors.testing_relevant_data || {}),
        differential_pressure_valve_b: dpbError,
      };
    }

    const cutoff = get("testing_relevant_data.pressurecutoff_fstep1_adj_to");
    if (
      cutoff !== null &&
      cutoff !== undefined &&
      dpa &&
      dpb &&
      Number(cutoff) >= Math.min(Number(dpa), Number(dpb))
    ) {
      errors.testing_relevant_data = {
        ...(errors.testing_relevant_data || {}),
        pressurecutoff_fstep1_adj_to:
          "It must be lower than the lowest of the ‘differential pressure A/B’ fields.",
      };
    }

    const maxSpeed = get("testing_relevant_data.max_speed_load");
    if (maxSpeed === null || maxSpeed === undefined || maxSpeed === "") {
      errors.testing_relevant_data = {
        ...(errors.testing_relevant_data || {}),
        max_speed_load: "Required",
      };
    } else {
      const num = Number(maxSpeed);
      if (isNaN(num)) {
        errors.testing_relevant_data = {
          ...(errors.testing_relevant_data || {}),
          max_speed_load: "Must be a number",
        };
      } else if (num < 500 || num > 4000) {
        errors.testing_relevant_data = {
          ...(errors.testing_relevant_data || {}),
          max_speed_load: "Must be between 500 and 4000",
        };
      } else if (num % 50 !== 0) {
        errors.testing_relevant_data = {
          ...(errors.testing_relevant_data || {}),
          max_speed_load: "Must be in steps of 50",
        };
      }
    }


    const boostPressure = get("testing_relevant_data.boost_pressure_at_load_speed");
    if (boostPressure === null || boostPressure === undefined || boostPressure === "") {
      errors.testing_relevant_data = {
        ...(errors.testing_relevant_data || {}),
        boost_pressure_at_load_speed: "Required",
      };
    } else {
      const num = Number(boostPressure);
      if (isNaN(num)) {
        errors.testing_relevant_data = {
          ...(errors.testing_relevant_data || {}),
          boost_pressure_at_load_speed: "Must be a number",
        };
      } else if (num < 18 || num > 40) {
        errors.testing_relevant_data = {
          ...(errors.testing_relevant_data || {}),
          boost_pressure_at_load_speed: "Must be between 18 and 40",
        };
      } else if (!Number.isInteger(num)) {
        errors.testing_relevant_data = {
          ...(errors.testing_relevant_data || {}),
          boost_pressure_at_load_speed: "Must be a whole number",
        };
      }
    }

    const validateStep = (val, step) => {
      const num = Number(val);
      if (isNaN(num)) return "Must be a number";
      if (num % step !== 0) return `Must be in steps of ${step}`;
      return null;
    };

    // Step 50 - optional fields
    const step50Fields = [
      "blockcurve_regstart_at",
      "blockcurve_regend_at",
      "q_char_regend",
      "at_working_pressure",
    ];

    step50Fields.forEach((field) => {
      const val = get(`testing_relevant_data.${field}`);
      if (val !== null && val !== undefined && val !== "") {
        const error = validateStep(val, 50);
        if (error) {
          errors.testing_relevant_data = {
            ...(errors.testing_relevant_data || {}),
            [field]: error,
          };
        }
      }
    });

    // Step 10 - optional fields
    const step10Fields = [
      "at_high_pressure_bc_re",
      "at_high_pressure_bc_rs",
    ];

    step10Fields.forEach((field) => {
      const val = get(`testing_relevant_data.${field}`);
      if (val !== null && val !== undefined && val !== "") {
        const error = validateStep(val, 10);
        if (error) {
          errors.testing_relevant_data = {
            ...(errors.testing_relevant_data || {}),
            [field]: error,
          };
        }
      }
    });

    return errors;
  };
  const formik = useFormik({
    initialValues: initialValues,
    validate: validateForm,
    validateOnMount: true,
    validateOnChange: true,
    enableReinitialize: true,
    onSubmit: (values) => { },
  });
  const axios = useAxios();
  const [customerNamePickList, setCustomerNamePickList] = useState([]);
  const [pickList, setPickList] = useState({});
  const rdre = params.rdre;

  const modelCode = useGeneratedModelCode();

  const handleClick = () => {
    const copyObject = { ...formik.values };
    dispatch({ type: SET_SCHEDE_TARATURA, value: copyObject });
    if (params?.id_configuration) {
      history.push(
        "/configuration/" +
        params.rdre +
        "/" +
        params.size +
        "/summary/" +
        params?.id_configuration
      );
    } else {
      history.push(
        "/configuration/" + params.rdre + "/" + params.size + "/summary"
      );
    }
  };

  const getPickList = () => {
    axios
      .get("calibration/GetPicklistValue", { params: { rdre: rdre } })
      .then((res) => {
        setPickList(res.data);
      })
      .catch((error) =>
        updateSnackbar({
          open: true,
          message: "Unable to get picklists",
          severity: "error",
        })
      );
  };


  /**
   *
   * @param {ChangeEvent} e event where the input value changes
   * @param {string} fieldName name of the field changed
   * change the value of the input and the computed field based on the field passed as parameter
   */
  const handleChangeComputedValue = async (e, fieldName) => {
    const rawValue = e.target.value;

    // Se vuoto, imposta null/"" (qui scegli tu cosa usare)
    const isEmpty = rawValue === "" || rawValue == null;
    const parsedValue = isEmpty ? null : parseInt(rawValue);

    // Applichiamo la logica solo se è un numero valido
    const boost = parseInt(formik?.values?.testing_relevant_data?.boost_pressure_at_load_speed) || 0;
    const diffA = parseInt(formik?.values?.testing_relevant_data?.differential_pressure_valve_a) || 0;
    const diffB = parseInt(formik?.values?.testing_relevant_data?.differential_pressure_valve_b) || 0;

    if (fieldName === "boost_pressure_at_load_speed") {
      await formik.setFieldValue("testing_relevant_data.boost_pressure_at_load_speed", isEmpty ? "" : parsedValue);

      const newReliefValveASetting = isEmpty ? "" : parsedValue + diffA;
      const newReliefValveBSetting = isEmpty ? "" : parsedValue + diffB;

      await formik.setFieldValue("testing_relevant_data.reliefvalvea_setting_abs", newReliefValveASetting);
      await formik.setFieldValue("testing_relevant_data.reliefvalve_b_setting_abs", newReliefValveBSetting);

      if (!isEmpty) {
        if (
          newReliefValveASetting > 500 &&
          formik?.values?.customer_data?.special_release === "Not specified"
        ) {
          await formik.setFieldValue("customer_data.special_release", "");
        } else if (newReliefValveASetting < 500) {
          await formik.setFieldValue("customer_data.special_release", "Not specified");
        }
      }

    } else if (fieldName === "differential_pressure_valve_a") {
      await formik.setFieldValue("testing_relevant_data.differential_pressure_valve_a", isEmpty ? "" : parsedValue);

      const newReliefValveASetting = isEmpty ? "" : boost + parsedValue;
      await formik.setFieldValue("testing_relevant_data.reliefvalvea_setting_abs", newReliefValveASetting);

      if (!isEmpty) {
        if (
          newReliefValveASetting > 500 &&
          formik?.values?.customer_data?.special_release === "Not specified"
        ) {
          await formik.setFieldValue("customer_data.special_release", "");
        } else if (newReliefValveASetting < 500) {
          await formik.setFieldValue("customer_data.special_release", "Not specified");
        }
      }

    } else if (fieldName === "differential_pressure_valve_b") {
      await formik.setFieldValue("testing_relevant_data.differential_pressure_valve_b", isEmpty ? "" : parsedValue);

      const newReliefValveBSetting = isEmpty ? "" : boost + parsedValue;
      await formik.setFieldValue("testing_relevant_data.reliefvalve_b_setting_abs", newReliefValveBSetting);
    }

    await formik.validateForm();
  };



  useEffect(() => {
    // getCalibration();
    getPickList();
    if (data?.discountInfo) {
      const item = data.discountInfo.find((d) => d.type === "customer");

      setCustomerNamePickList([
        {
          id: 1,
          value: "No",
        },
        {
          id: 2,
          value: item.optionValue,
        },
      ]);
    }

    if (data?.schedeTaratura) {
      Object.keys(data?.schedeTaratura?.testing_relevant_data).forEach(
        (key) => {
          if (
            data.schedeTaratura.testing_relevant_data[key] &&
            (key !== "nominal_voltage" ||
              key !== "pressurecutoff_fstep1_adj_to")
          ) {
            data.schedeTaratura.testing_relevant_data[key] = parseFloat(
              data.schedeTaratura.testing_relevant_data[key]
            );
          }
        }
      );
    }

    const values = {
      info: {
        version_text: data?.schedeTaratura?.info?.version_text || "",
      },
      general_info_features: {
        material_description: modelCode || "",
      },
      customer_data: {
        rd_sheet_prospectus:
          data?.schedeTaratura?.customer_data.rd_sheet_prospectus || "RE92004",
        customer: data?.schedeTaratura?.customer_data?.customer || {
          id: 0,
          value: "No",
        },
        customer_pn: data?.schedeTaratura?.customer_data?.customer_pn || "",
        special_release_no:
          data?.schedeTaratura?.testing_relevant_data
            ?.reliefvalve_b_setting_abs &&
            data?.schedeTaratura?.testing_relevant_data
              ?.reliefvalve_b_setting_abs > 500
            ? data?.schedeTaratura?.customer_data?.special_release_no || ""
            : "Not specified", //dipende dal campo b38
        name_plate_standard:
          !data?.schedeTaratura?.customer_data?.customer || data?.schedeTaratura?.customer_data?.customer === "No"
            ? "standard without customer number"
            : "standard with customer number", //se c'è il customer allora "standard with customer number", se no "standard without customer number
        application_dc_branch_code: data?.schedeTaratura?.customer_data
          ?.application_dc_branch_code || {
          id: 3,
          value: "OTHERS",
        },
        // !
        // approval_company_external:
        //   data?.accessories?.find(
        //     (a) => a.value.accessory === "Test Certificates"
        //   )?.value?.value !== "Inspection certific.3.1 apiece"
        //     ? {
        //       id: 233,
        //       value: "Standard(without homologation)",
        //     }
        //     : data?.schedeTaratura?.customer_data?.approval_company_external ||
        //     null,
        // test_certificate:
        //   data?.accessories?.find(
        //     (a) => a.value.accessory === "Test Certificates"
        //   )?.value?.value === "No"
        //     ? {
        //       id: 250,
        //       value: "without",
        //     }
        //     : data?.schedeTaratura?.customer_data?.test_certificate || null,
        // language_code_f_test_certif:
        //   data?.accessories?.find(
        //     (a) => a.value.accessory === "Test Certificates"
        //   )?.value?.value === "No"
        //     ? {
        //       id: 276,
        //       value: "without",
        //     }
        //     : data?.schedeTaratura?.customer_data
        //       ?.language_code_f_test_certif || null,
        paintprimer:
          data?.accessories?.find((a) => a.family === "S6")?.value?.value ===
            "No" &&
            data?.accessories?.find((a) => a.family === "S7")?.value?.value ===
            "No"
            ? {
              id: 142,
              value: "without",
            }
            : data?.schedeTaratura?.customer_data?.paintprimer || null,
        painttop_coat:
          data?.accessories?.find((a) => a.family === "S7")?.value?.value ===
            "No"
            ? {
              id: 185,
              value: "without",
            }
            : data?.schedeTaratura?.customer_data?.painttop_coat || null,
        // paint_specification:
        //   data?.accessories?.find((a) => a.family === "S6")?.value?.value ===
        //     "No" &&
        //     data?.accessories?.find((a) => a.family === "S7")?.value?.value ===
        //     "No"
        //     ? {
        //       id: 222,
        //       value: "without",
        //     }
        //     : data?.schedeTaratura?.customer_data?.paint_specification || null,
        conservation: data?.schedeTaratura?.customer_data?.conservation || {
          id: 111,
          value: "without",
        },
      },
      assembly_rel_data: {
        moa_hw_lever:
          data?.specs?.find((a) => a.position_desc === "Control device")?.value
            ?.value !== "HW"
            ? {
              id: 121,
              value: "Not Specified",
            }
            : data?.schedeTaratura?.assembly_rel_data?.moa_hw_lever || null,
        moa_solenoids:
          data?.schedeTaratura?.assembly_rel_data?.moa_solenoids || null,
        moa_pumpsupporttheads_position: data?.schedeTaratura?.assembly_rel_data
          ?.moa_pumpsupporttheads_position || {
          id: 116,
          value: "OHNE ANGABE",
        },
        // moa_sv_in_port_block: data?.schedeTaratura?.assembly_rel_data
        //   ?.moa_sv_in_port_block || { id: 147, value: "Not specified" },
        // moa_pump_testing: { id: 126, value: "000 STANDARD" },
      },
      testing_relevant_data: {
        testing_temperature_c:
          data?.specs?.find((a) => a.position_desc === "DA control valve (only for NG110 and 125)")
            ?.value?.value !== "1"
            ? "40"
            : "65",
        max_speed_load:
          data?.schedeTaratura?.testing_relevant_data?.max_speed_load || null,
        // max_speed_wo_load:
        //   data?.schedeTaratura?.testing_relevant_data?.max_speed_wo_load ||
        //   null,
        // input_power:
        //   data?.schedeTaratura?.testing_relevant_data?.input_power || null,
        boost_pressure_at_load_speed:
          data?.schedeTaratura?.testing_relevant_data
            ?.boost_pressure_at_load_speed || null,
        max_displacement_a_ccm:
          data?.schedeTaratura?.testing_relevant_data?.max_displacement_a_ccm ||
          null,
        max_displacement_b_ccm:
          data?.schedeTaratura?.testing_relevant_data?.max_displacement_b_ccm ||
          null,
        reliefvalve_b_setting_abs:
          data?.schedeTaratura?.testing_relevant_data
            ?.reliefvalve_b_setting_abs || 0,
        reliefvalvea_setting_abs:
          data?.schedeTaratura?.testing_relevant_data
            ?.reliefvalvea_setting_abs || 0,
        at_high_pressure_bc_re:
          data?.specs?.find((a) => a.position_desc === "DA control valve (only for NG110 and 125)")
            ?.value?.value !== "0"
            ? data?.schedeTaratura?.testing_relevant_data
              ?.at_high_pressure_bc_re || null
            : null,
        at_high_pressure_bc_rs:
          data?.specs?.find((a) => a.position_desc === "DA control valve (only for NG110 and 125)")
            ?.value?.value !== "0"
            ? data?.schedeTaratura?.testing_relevant_data
              ?.at_high_pressure_bc_rs || null
            : null,
        at_working_pressure:
          data?.specs?.find((a) => a.position_desc === "DA control valve (only for NG110 and 125)")
            ?.value?.value !== "0"
            ? data?.schedeTaratura?.testing_relevant_data
              ?.at_working_pressure || null
            : null,
        blockcurve_regend_at:
          data?.specs?.find((a) => a.position_desc === "DA control valve (only for NG110 and 125)")
            ?.value?.value !== "0"
            ? data?.schedeTaratura?.testing_relevant_data
              ?.blockcurve_regend_at || null
            : null,
        blockcurve_regstart_at:
          data?.specs?.find((a) => a.position_desc === "DA control valve (only for NG110 and 125)")
            ?.value?.value !== "0"
            ? data?.schedeTaratura?.testing_relevant_data
              ?.blockcurve_regstart_at || null
            : null,
        nominal_voltage:
          data?.schedeTaratura?.testing_relevant_data?.nominal_voltage || null,
        pressurecutoff_fstep1_adj_to:
          data?.specs?.find((a) => a.position_desc === "Pressure cut-off")
            ?.value?.value === "0"
            ? "Without"
            : data?.schedeTaratura?.testing_relevant_data
              ?.pressurecutoff_fstep1_adj_to || "",
        q_char_regend:
          data?.specs?.find((a) => a.position_desc === "DA control valve (only for NG110 and 125)")
            ?.value?.value !== "0"
            ? data?.schedeTaratura?.testing_relevant_data?.q_char_regend || null
            : null,
        // at_pilot_pressure:
        //   data?.schedeTaratura?.testing_relevant_data?.at_pilot_pressure ||
        //   null,
        differential_pressure_valve_a:
          data?.schedeTaratura?.testing_relevant_data
            ?.differential_pressure_valve_a || null,
        differential_pressure_valve_b:
          data?.schedeTaratura?.testing_relevant_data
            ?.differential_pressure_valve_b || null,
      },
      special_features: {
        note: data?.schedeTaratura?.special_features?.note || "",
      },
    };

    setInitialValues(values);
  }, [data]);

  // 
  

  return (
    <form
      id="schede_taratura_form"
      style={{
        padding: "24px",
        borderRadius: "20px",
        backgroundColor: "white",
      }}
      onSubmit={formik.handleSubmit}
    >
      <h1> Scheda di taratura A4vg</h1>
      <Grid container spacing={2}>
        {/* <Grid item xs={3}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>R8M_1_PV5701V</p>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              padding: "15px 20px",
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              borderRadius: "15px",
              position: "relative",
              boxShadow:
                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
            }}
          >
            <input
              disabled={readOnly}
              style={{
                outline: "none",
                border: "none",
                backgroundColor: "transparent",
                width: "100%",
              }}
              name={"info.version_text"}
              value={formik?.values?.info?.version_text || ""}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>
        </Grid> */}
        <Grid item xs={12}>
          <h2>General Info Features</h2>
        </Grid>

        <Grid item xs={4}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
            Material Description
          </p>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              padding: "15px 20px",
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              borderRadius: "15px",
              position: "relative",
              boxShadow:
                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
            }}
          >
            <input
              disabled={true}
              style={{
                outline: "none",
                border: "none",
                backgroundColor: "transparent",
                width: "100%",
              }}
              name={"general_info_features.material_description"}
              value={
                formik?.values?.general_info_features?.material_description ||
                ""
              }
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>
        </Grid>

        <Grid item xs={12}>
          <h2>Customer Data</h2>
        </Grid>
        <Grid item xs={3}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
            RD-Sheet (Prospectus){" "}
          </p>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              padding: "15px 20px",
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              borderRadius: "15px",
              position: "relative",
              boxShadow:
                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
            }}
          >
            <input
              disabled={true}
              style={{
                outline: "none",
                border: "none",
                backgroundColor: "transparent",
                width: "100%",
              }}
              name={"customer_data.rd_sheet_prospectus"}
              value={formik?.values?.customer_data?.rd_sheet_prospectus || ""}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>
        </Grid>

        <Grid item xs={3}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>Customer name</p>

          <MyAutocomplete
            isMultiple={false}
            defaultValue={formik?.values?.customer_data?.customer || null} // Valore di default del campo customer
            onChange={(e, c) => {
              formik.setFieldValue("customer_data.customer", c);
              

              if (c.value === "No") {
                formik.setFieldValue(
                  "customer_data.name_plate_standard",
                  "standard without customer number"
                );
              } else {
                formik.setFieldValue(
                  "customer_data.name_plate_standard",
                  "standard with customer number"
                );
              }

            }}
            disabled={readOnly}
            data={customerNamePickList} // Lista di opzioni
            name="customer_data.customer"
            label={""}
          />
        </Grid>

        {formik?.values?.customer_data?.customer &&
          formik?.values?.customer_data?.customer?.value !== "No" && (
            <Grid item xs={3}>
              <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
                Customer p/n
              </p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "15px 20px",
                  backgroundColor: "rgba(255, 255, 255, 0.5)",
                  borderRadius: "15px",
                  position: "relative",
                  boxShadow:
                    "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
                }}
              >
                <input
                  style={{
                    outline: "none",
                    border: "none",
                    backgroundColor: "transparent",
                    width: "100%",
                  }}
                  disabled={readOnly}
                  name={"customer_data.customer_pn"}
                  value={formik?.values?.customer_data?.customer_pn || ""}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>
            </Grid>
          )}

        <Grid item xs={3}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
            Name plate standard
          </p>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              padding: "15px 20px",
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              borderRadius: "15px",
              position: "relative",
              boxShadow:
                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
            }}
          >
            <input
              disabled={true}
              style={{
                outline: "none",
                border: "none",
                backgroundColor: "transparent",
                width: "100%",
              }}
              name={"customer_data.name_plate_standard"}
              value={formik?.values?.customer_data?.name_plate_standard || ""}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>
        </Grid>
        <Grid item xs={3}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
            application - DC-Branch-Code
          </p>

          <MyAutocomplete
            isMultiple={false}
            defaultValue={
              formik?.values?.customer_data?.application_dc_branch_code || null
            } // Valore di default del campo customer
            onChange={(e, c) => {
              formik.setFieldValue(
                "customer_data.application_dc_branch_code",
                c
              );
            }}
            disabled={readOnly}
            data={pickList?.application_dc_branch_code || []} // Lista di opzioni
            name="customer_data.application_dc_branch_code"
            label={""}
          />
        </Grid>

        {/* <Grid item xs={3}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
            Approval Company (External)
          </p>
         
          <MyAutocomplete
            isMultiple={false}
            disabled={
              readOnly
                ? readOnly
                : data?.accessories?.find(
                  (a) => a.value.accessory === "Test Certificates"
                )?.value?.value !== "Inspection certific.3.1 apiece"
            }
            defaultValue={
              formik?.values?.customer_data?.approval_company_external || null
            } 
            onChange={(e, c) => {
              formik.setFieldValue(
                "customer_data.approval_company_external",
                c
              );
            }}
            data={pickList?.approval_company_external || []} 
            name="customer_data.approval_company_external"
            label={""}
          />
        </Grid> */}

        {/* <Grid item xs={3}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
            Test Certificate
          </p>

          <MyAutocomplete
            isMultiple={false}
            disabled={
              readOnly
                ? readOnly
                : data?.accessories?.find(
                  (a) => a.value.accessory === "Test Certificates"
                )?.value?.value === "No"
            }
            defaultValue={
              formik?.values?.customer_data?.test_certificate || null
            } // Valore di default del campo customer
            onChange={(e, c) => {
              formik.setFieldValue("customer_data.test_certificate", c);
            }}
            data={pickList?.test_certificate || []} // Lista di opzioni
            name="customer_data.test_certificate"
            label={""}
          />
        </Grid> */}

        {/* <Grid item xs={3}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>Language code</p>

          <MyAutocomplete
            isMultiple={false}
            disabled={
              readOnly
                ? readOnly
                : data?.accessories?.find(
                  (a) => a.value.accessory === "Test Certificates"
                )?.value?.value === "No"
            }
            defaultValue={
              formik?.values?.customer_data?.language_code_f_test_certif || null
            } // Valore di default del campo customer
            onChange={(e, c) => {
              formik.setFieldValue(
                "customer_data.language_code_f_test_certif",
                c
              );
            }}
            data={pickList?.language_code_f_test_certif || []} // Lista di opzioni
            name="customer_data.language_code_f_test_certif"
            label={""}
          />
        </Grid> */}

        <Grid item xs={3}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>Paint/Primer</p>

          <MyAutocomplete
            isMultiple={false}
            disabled={
              readOnly
                ? readOnly
                : data?.accessories?.find((a) => a.family === "S6")?.value
                  ?.value === "No" &&
                data?.accessories?.find((a) => a.family === "S7")?.value
                  ?.value === "No"
            }
            defaultValue={formik?.values?.customer_data?.paintprimer || null} // Valore di default del campo customer
            onChange={(e, c) => {
              formik.setFieldValue("customer_data.paintprimer", c);
            }}
            data={pickList?.paintprimer || []} // Lista di opzioni
            name="customer_data.paintprimer"
            label={""}
          />
        </Grid>

        <Grid item xs={3}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
            Paint/top coat
          </p>

          <MyAutocomplete
            isMultiple={false}
            disabled={
              readOnly
                ? readOnly
                : data?.accessories?.find((a) => a.family === "S7")?.value
                  ?.value === "No"
            }
            defaultValue={formik?.values?.customer_data?.painttop_coat || null} // Valore di default del campo customer
            onChange={(e, c) => {
              formik.setFieldValue("customer_data.painttop_coat", c);
            }}
            data={pickList?.painttop_coat || []} // Lista di opzioni
            name="customer_data.painttop_coat"
            label={""}
          />
        </Grid>

        {/* <Grid item xs={3}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
            Paint Specification
          </p>

          <MyAutocomplete
            isMultiple={false}
            disabled={
              readOnly
                ? readOnly
                : data?.accessories?.find((a) => a.family === "S6")?.value
                  ?.value === "No" &&
                data?.accessories?.find((a) => a.family === "S7")?.value
                  ?.value === "No"
            }
            defaultValue={
              formik?.values?.customer_data?.paint_specification || null
            } // Valore di default del campo customer
            onChange={(e, c) => {
              formik.setFieldValue("customer_data.paint_specification", c);
            }}
            data={pickList?.paint_specification || []} // Lista di opzioni
            name="customer_data.paint_specification"
            label={""}
          />
        </Grid> */}

        <Grid item xs={3}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>Conservation</p>

          <MyAutocomplete
            isMultiple={false}
            defaultValue={formik?.values?.customer_data?.conservation || null} // Valore di default del campo customer
            onChange={(e, c) => {
              formik.setFieldValue("customer_data.conservation", c);
            }}
            disabled={readOnly}
            data={pickList?.conservation || []} // Lista di opzioni
            name="customer_data.conservation"
            label={""}
          />
        </Grid>

        <Grid item xs={12}>
          <h2>ASSEMBLY REL. DATA</h2>
        </Grid>

        <Grid item xs={3}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>MOA HW-lever</p>

          <MyAutocomplete
            isMultiple={false}
            disabled={
              readOnly
                ? readOnly
                : data?.specs?.find((a) => a.position_desc === "Control device")
                  ?.value?.value !== "HW"
            }
            defaultValue={
              formik?.values?.assembly_rel_data?.moa_hw_lever || null
            } // Valore di default del campo customer
            onChange={(e, c) => {
              formik.setFieldValue("assembly_rel_data.moa_hw_lever", c);
            }}
            data={pickList?.moa_hw_lever || []} // Lista di opzioni
            name="assembly_rel_data.moa_hw_lever"
            label={""}
          />
        </Grid>

        <Grid item xs={3}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>MOA Solenoids</p>

          <MyAutocomplete
            isMultiple={false}
            disabled={readOnly}
            defaultValue={
              formik?.values?.assembly_rel_data?.moa_solenoids || null
            } // Valore di default del campo customer
            onChange={(e, c) => {
              formik.setFieldValue("assembly_rel_data.moa_solenoids", c);
            }}
            data={pickList?.moa_solenoids || []} // Lista di opzioni
            name="assembly_rel_data.moa_solenoids"
            label={""}
          />
        </Grid>

        <Grid item xs={3}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
            MOA PumpSupportTheads Position
          </p>

          <MyAutocomplete
            isMultiple={false}
            defaultValue={
              formik?.values?.assembly_rel_data
                ?.moa_pumpsupporttheads_position || null
            } // Valore di default del campo customer
            onChange={(e, c) => {
              formik.setFieldValue(
                "assembly_rel_data.moa_pumpsupporttheads_position",
                c
              );
            }}
            disabled={readOnly}
            data={pickList?.moa_pumpsupporttheads_position || []} // Lista di opzioni
            name="assembly_rel_data.moa_pumpsupporttheads_position"
            label={""}
          />
        </Grid>

        {/* <Grid item xs={3}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
            MOA SV in port block
          </p>

          <MyAutocomplete
            isMultiple={false}
            disabled={readOnly}
            defaultValue={
              formik?.values?.assembly_rel_data?.moa_sv_in_port_block || null
            } // Valore di default del campo customer
            onChange={(e, c) => {
              formik.setFieldValue("assembly_rel_data.moa_sv_in_port_block", c);
            }}
            data={pickList?.moa_sv_in_port_block || []} // Lista di opzioni
            name="assembly_rel_data.moa_sv_in_port_block"
            label={""}
          />
        </Grid> */}

        <Grid item xs={3}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
            MOA Pump Testing
          </p>

          <MyAutocomplete
            isMultiple={false}
            disabled={true}
            defaultValue={
              formik?.values?.assembly_rel_data?.moa_pump_testing || null
            } // Valore di default del campo customer
            onChange={(e, c) => {
              formik.setFieldValue("assembly_rel_data.moa_pump_testing", c);
            }}
            data={pickList?.moa_flushing_valve_port_t || []} // Lista di opzioni
            name="assembly_rel_data.moa_pump_testing"
            label={""}
          />
        </Grid>

        <Grid item xs={12}>
          <h2>TESTING RELEVANT DATA</h2>
        </Grid>

        <Grid item xs={3}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
            Testing Temperature °C
          </p>

          <div
            style={{
              display: "flex",
              gap: 3,
              padding: "15px 20px",
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              borderRadius: "15px",
              position: "relative",
              boxShadow:
                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
            }}
          >
            <input
              style={{
                outline: "none",
                border: "none",
                backgroundColor: "transparent",
                width: "100%",
              }}
              disabled={true}
              type="number"
              name={"testing_relevant_data.testing_temperature_c"}
              value={
                formik?.values?.testing_relevant_data?.testing_temperature_c
              }
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>
        </Grid>

        <Grid item xs={3}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
            Max. Speed (Load)
          </p>

          <div
            style={{
              display: "flex",
              outline: formik.errors.testing_relevant_data?.max_speed_load ? '1px solid red' : "none",
              gap: 3,
              padding: "15px 20px",
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              borderRadius: "15px",
              position: "relative",
              boxShadow:
                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
            }}
          >
            <input
              style={{
                outline: "none",
                border: "none",
                backgroundColor: "transparent",
                width: "100%",
              }}
              disabled={readOnly}
              type="number"
              onWheel={(e) => e.target.blur()}
              name={"testing_relevant_data.max_speed_load"}
              value={formik?.values?.testing_relevant_data?.max_speed_load}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik?.errors?.testing_relevant_data?.max_speed_load && <p style={{ color: "red", fontSize: 12, fontWeight: "bold" }}>
              {formik?.errors?.testing_relevant_data?.max_speed_load}
            </p>}

          </div>
        </Grid>

        {/* <Grid item xs={3}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
            Max. Speed (w.o. Load)
          </p>

          <div
            style={{
              display: "flex",
              gap: 3,
              padding: "15px 20px",
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              borderRadius: "15px",
              position: "relative",
              boxShadow:
                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
            }}
          >
            <input
              style={{
                outline: "none",
                border: "none",
                backgroundColor: "transparent",
                width: "100%",
              }}
              disabled={readOnly}
              type="number"
              name={"testing_relevant_data.max_speed_wo_load"}
              value={formik?.values?.testing_relevant_data?.max_speed_wo_load}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <p style={{ color: "orange", fontSize: 12, fontWeight: "bold" }}>
              Number between 500-4000 by increments of 50
            </p>
          </div>
        </Grid> */}

        {/* <Grid item xs={3}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>Input Power</p>
          <div
            style={{
              display: "flex",
              gap: 3,
              padding: "15px 20px",
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              borderRadius: "15px",
              position: "relative",
              boxShadow:
                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
            }}
          >
            <input
              style={{
                outline: "none",
                border: "none",
                backgroundColor: "transparent",
                width: "100%",
              }}
              disabled={readOnly}
              type="number"
              name={"testing_relevant_data.input_power"}
              value={formik?.values?.testing_relevant_data?.input_power || null}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <p style={{ color: "orange", fontSize: 12, fontWeight: "bold" }}>
              Number between 500-4000 by increments of 50
            </p>
          </div>
        </Grid> */}

        <Grid item xs={3}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
            Boost Pressure at Load Speed
          </p>

          <div
            style={{
              display: "flex",
              outline: formik.errors.testing_relevant_data?.boost_pressure_at_load_speed ? '1px solid red' : "none",
              gap: 3,
              padding: "15px 20px",
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              borderRadius: "15px",
              position: "relative",
              boxShadow:
                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
            }}
          >
            <input
              style={{
                outline: "none",
                border: "none",
                backgroundColor: "transparent",
                width: "100%",
              }}
              disabled={readOnly}
              type="number"
              onWheel={(e) => e.target.blur()}
              name={"testing_relevant_data.boost_pressure_at_load_speed"}
              value={
                formik?.values?.testing_relevant_data
                  ?.boost_pressure_at_load_speed
              }
              onChange={(e) =>
                handleChangeComputedValue(e, "boost_pressure_at_load_speed")
              }
              onBlur={formik.handleBlur}
            />
            {formik.errors.testing_relevant_data?.boost_pressure_at_load_speed && <p style={{ color: "red", fontSize: 12, fontWeight: "bold" }}>
              {formik.errors.testing_relevant_data?.boost_pressure_at_load_speed}
            </p>}

          </div>
        </Grid>

        <Grid item xs={3}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
            Max. Displacement A (ccm)
          </p>

          <div
            style={{
              display: "flex",
              gap: 3,
              padding: "15px 20px",
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              borderRadius: "15px",
              position: "relative",
              boxShadow:
                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
            }}
          >
            <input
              style={{
                outline: "none",
                border: "none",
                backgroundColor: "transparent",
                width: "100%",
              }}
              disabled={readOnly}
              type="number"
              name={"testing_relevant_data.max_displacement_a_ccm"}
              value={
                formik?.values?.testing_relevant_data?.max_displacement_a_ccm
              }
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>
        </Grid>

        <Grid item xs={3}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
            Max. Displacement B (ccm)
          </p>

          <div
            style={{
              display: "flex",
              gap: 3,
              padding: "15px 20px",
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              borderRadius: "15px",
              position: "relative",
              boxShadow:
                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
            }}
          >
            <input
              style={{
                outline: "none",
                border: "none",
                backgroundColor: "transparent",
                width: "100%",
              }}
              disabled={readOnly}
              type="number"
              name={"testing_relevant_data.max_displacement_b_ccm"}
              value={
                formik?.values?.testing_relevant_data?.max_displacement_b_ccm ||
                ""
              }
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>
        </Grid>

        <Grid item xs={3}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
            ReliefValve.A Setting abs.
          </p>

          <div
            style={{
              display: "flex",
              gap: 3,
              padding: "15px 20px",
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              borderRadius: "15px",
              position: "relative",
              boxShadow:
                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
            }}
          >
            <input
              style={{
                outline: "none",
                border: "none",
                backgroundColor: "transparent",
                width: "100%",
              }}
              disabled={true}
              type="number"
              name={"testing_relevant_data.reliefvalvea_setting_abs"}
              value={
                formik?.values?.testing_relevant_data
                  ?.differential_pressure_valve_a +
                formik?.values?.testing_relevant_data
                  ?.boost_pressure_at_load_speed || 0
              }
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>
        </Grid>

        <Grid item xs={3}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
            Differential Pressure Valve A
          </p>

          <div
            style={{
              display: "flex",
              gap: 3,
              outline: formik.errors.testing_relevant_data?.differential_pressure_valve_a ? '1px solid red' : "none",
              padding: "15px 20px",
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              borderRadius: "15px",
              position: "relative",
              boxShadow:
                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
            }}
          >
            <input

              style={{
                outline: "none",
                border: "none",
                backgroundColor: "transparent",
                width: "100%",
              }}
              disabled={readOnly}
              type="number"
              onWheel={(e) => e.target.blur()}
              name={"testing_relevant_data.differential_pressure_valve_a"}
              value={
                formik?.values?.testing_relevant_data
                  ?.differential_pressure_valve_a
              }
              onChange={(e) =>
                handleChangeComputedValue(e, "differential_pressure_valve_a")
              }
              onBlur={formik.handleBlur}
            />
            {/* {formik?.errors?.differential_pressure_valve_a && <p style={{ color: "red", fontSize: 12, fontWeight: "bold" }}>
              Number between 300-530 by increments of 10
            </p>} */}
            {formik.errors.testing_relevant_data?.differential_pressure_valve_a && (
              <p style={{ color: "red", fontSize: 12, fontWeight: "bold" }}>
                {formik.errors.testing_relevant_data.differential_pressure_valve_a}
              </p>
            )}
          </div>
        </Grid>

        <Grid item xs={3}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
            ReliefValve.B Setting abs.
          </p>

          <div
            style={{
              display: "flex",
              gap: 3,
              padding: "15px 20px",
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              borderRadius: "15px",
              position: "relative",
              boxShadow:
                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
            }}
          >
            <input
              style={{
                outline: "none",
                border: "none",
                backgroundColor: "transparent",
                width: "100%",
              }}
              disabled={true}
              type="number"
              name={"testing_relevant_data.reliefvalve_b_setting_abs"}
              value={
                formik?.values?.testing_relevant_data
                  ?.differential_pressure_valve_b +
                formik?.values?.testing_relevant_data
                  ?.boost_pressure_at_load_speed || 0
              }
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>
        </Grid>

        <Grid item xs={3}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
            Differential Pressure Valve B
          </p>

          <div
            style={{
              display: "flex",
              outline: formik.errors.testing_relevant_data?.differential_pressure_valve_b ? '1px solid red' : "none",
              gap: 3,
              padding: "15px 20px",
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              borderRadius: "15px",
              position: "relative",
              boxShadow:
                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
            }}
          >
            <input
              style={{
                outline: "none",

                border: "none",
                backgroundColor: "transparent",
                width: "100%",
              }}
              disabled={readOnly}
              type="number"
              onWheel={(e) => e.target.blur()}
              name={"testing_relevant_data.differential_pressure_valve_b"}
              value={
                formik?.values?.testing_relevant_data
                  ?.differential_pressure_valve_b
              }
              onChange={(e) =>
                handleChangeComputedValue(e, "differential_pressure_valve_b")
              }
              onBlur={formik.handleBlur}
            />
            {/* <p style={{ color: "orange", fontSize: 12, fontWeight: "bold" }}>
              Number between 300-530 by increments of 10
            </p> */}
            {formik.errors.testing_relevant_data?.differential_pressure_valve_b && (
              <p style={{ color: "red", fontSize: 12, fontWeight: "bold" }}>
                {formik.errors.testing_relevant_data.differential_pressure_valve_b}
              </p>
            )}
          </div>
        </Grid>
        <Grid item xs={3}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
            Special Release No.
          </p>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              padding: "15px 20px",
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              borderRadius: "15px",
              position: "relative",
              boxShadow:
                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
            }}
          >
            <input
              style={{
                outline: "none",
                border: "none",
                backgroundColor: "transparent",
                width: "100%",
              }}
              disabled={
                readOnly ||
                formik?.values?.testing_relevant_data
                  ?.reliefvalve_b_setting_abs < 500
              }
              name={"customer_data.special_release_no"}
              value={formik?.values?.customer_data?.special_release_no || ""}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>
        </Grid>
        <Grid item xs={3}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
            PressureCutOff F.Step1 adj. to
          </p>

          <div
            style={{
              display: "flex",
              gap: 3,
              outline: formik.errors.testing_relevant_data?.pressurecutoff_fstep1_adj_to ? '1px solid red' : "none",
              padding: "15px 20px",
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              borderRadius: "15px",
              position: "relative",
              boxShadow:
                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
            }}
          >
            <input
              style={{
                outline: "none",
                border: "none",
                backgroundColor: "transparent",
                width: "100%",
              }}
              name={"testing_relevant_data.pressurecutoff_fstep1_adj_to"}
              value={
                formik?.values?.testing_relevant_data
                  ?.pressurecutoff_fstep1_adj_to || ""
              }
              disabled={
                readOnly
                  ? readOnly
                  : data?.specs?.find(
                    (a) => a.position_desc === "Pressure cut-off"
                  )?.value?.value !== "D"
              }
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.errors.testing_relevant_data?.pressurecutoff_fstep1_adj_to && <p style={{ color: "red", fontSize: 12, fontWeight: "bold" }}>
              {/* It must be lower than the lowest of the ‘differential pressure A/B’ fields. */}
              {formik.errors.testing_relevant_data.pressurecutoff_fstep1_adj_to}
            </p>}

          </div>
        </Grid>

        {/* <Grid item xs={3}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
            At Pilot Pressure
          </p>

          <div
            style={{
              display: "flex",
              gap: 3,
              padding: "15px 20px",
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              borderRadius: "15px",
              position: "relative",
              boxShadow:
                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
            }}
          >
            <input
              style={{
                outline: "none",
                border: "none",
                backgroundColor: "transparent",
                width: "100%",
              }}
              disabled={readOnly}
              type="number"
              name={"testing_relevant_data.at_pilot_pressure"}
              value={formik?.values?.testing_relevant_data?.at_pilot_pressure}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>
        </Grid> */}

        <Grid item xs={3}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
            Nominal Voltage (Control)
          </p>

          <MyAutocomplete
            isMultiple={false}
            defaultValue={
              formik?.values?.testing_relevant_data?.nominal_voltage || null
            } // Valore di default del campo customer
            onChange={(e, c) => {
              formik.setFieldValue("testing_relevant_data.nominal_voltage", c);
            }}
            disabled={readOnly}
            data={pickList?.nominal_voltage || []} // Lista di opzioni
            name="testing_relevant_data.nominal_voltage"
            label={""}
          />
        </Grid>

        {data?.specs?.find((a) => a.position_desc === "DA control valve (only for NG110 and 125)")
          ?.value?.value !== "0" && <>
            <Grid item xs={3}>
              <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
                Blockcurve Reg.Start at
              </p>

              <div
                style={{
                  display: "flex",
                  outline: formik.errors.testing_relevant_data?.blockcurve_regstart_at ? '1px solid red' : "none",
                  gap: 3,
                  padding: "15px 20px",
                  backgroundColor: "rgba(255, 255, 255, 0.5)",
                  borderRadius: "15px",
                  position: "relative",
                  boxShadow:
                    "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
                }}
              >
                <input
                  style={{
                    outline: "none",
                    border: "none",
                    backgroundColor: "transparent",
                    width: "100%",
                  }}
                  type={
                    'number'
                  }
                  disabled={
                    readOnly
                    // ? readOnly
                    // : data?.specs?.find(
                    //   (a) => a.position_desc === "DA control valve (only for NG110 and 125)"
                    // )?.value?.value === "1"
                  }
                  name={"testing_relevant_data.blockcurve_regstart_at"}
                  value={
                    formik?.values?.testing_relevant_data?.blockcurve_regstart_at
                  }
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.errors.testing_relevant_data?.blockcurve_regstart_at && (
                  <p style={{ color: "red", fontSize: 12, fontWeight: "bold" }}>
                    {formik.errors.testing_relevant_data?.blockcurve_regstart_at}

                  </p>
                )}
              </div>
            </Grid>

            <Grid item xs={3}>
              <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
                At High Pressure BC Rs
              </p>

              <div
                style={{
                  display: "flex",
                  outline: formik.errors.testing_relevant_data?.at_high_pressure_bc_rs ? '1px solid red' : "none",
                  gap: 3,
                  padding: "15px 20px",
                  backgroundColor: "rgba(255, 255, 255, 0.5)",
                  borderRadius: "15px",
                  position: "relative",
                  boxShadow:
                    "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
                }}
              >
                <input
                  style={{
                    outline: "none",
                    border: "none",
                    backgroundColor: "transparent",
                    width: "100%",
                  }}
                  type={
                    'number'
                  }
                  disabled={
                    readOnly
                    // ? readOnly
                    // : data?.specs?.find(
                    //   (a) => a.position_desc === "DA control valve (only for NG110 and 125)"
                    // )?.value?.value === "1"
                  }
                  name={"testing_relevant_data.at_high_pressure_bc_rs"}
                  value={
                    formik?.values?.testing_relevant_data?.at_high_pressure_bc_rs
                  }
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.errors.testing_relevant_data?.at_high_pressure_bc_rs && (
                  <p style={{ color: "red", fontSize: 12, fontWeight: "bold" }}>
                    {formik.errors.testing_relevant_data?.at_high_pressure_bc_rs}

                  </p>
                )}
              </div>
            </Grid>

            <Grid item xs={3}>
              <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
                Blockcurve Reg.End at
              </p>


              <div
                style={{
                  display: "flex",
                  outline: formik.errors.testing_relevant_data?.blockcurve_regend_at ? '1px solid red' : "none",
                  gap: 3,
                  padding: "15px 20px",
                  backgroundColor: "rgba(255, 255, 255, 0.5)",
                  borderRadius: "15px",
                  position: "relative",
                  boxShadow:
                    "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
                }}
              >
                <input
                  style={{
                    outline: "none",
                    border: "none",
                    backgroundColor: "transparent",
                    width: "100%",
                  }}
                  type={
                    'number'
                  }
                  disabled={
                    readOnly
                    // ? readOnly
                    // : data?.specs?.find(
                    //   (a) => a.position_desc === "DA control valve (only for NG110 and 125)"
                    // )?.value?.value === "1"
                  }
                  name={"testing_relevant_data.blockcurve_regend_at"}
                  value={
                    formik?.values?.testing_relevant_data?.blockcurve_regend_at
                  }
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.errors.testing_relevant_data?.blockcurve_regend_at && (
                  <p style={{ color: "red", fontSize: 12, fontWeight: "bold" }}>
                    {formik.errors.testing_relevant_data?.blockcurve_regend_at}

                  </p>
                )}
              </div>
            </Grid>

            <Grid item xs={3}>
              <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
                At High Pressure BC Re
              </p>

              <div
                style={{
                  display: "flex",
                  outline: formik.errors.testing_relevant_data?.at_high_pressure_bc_re ? '1px solid red' : "none",
                  gap: 3,
                  padding: "15px 20px",
                  backgroundColor: "rgba(255, 255, 255, 0.5)",
                  borderRadius: "15px",
                  position: "relative",
                  boxShadow:
                    "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
                }}
              >
                <input
                  style={{
                    outline: "none",
                    border: "none",
                    backgroundColor: "transparent",
                    width: "100%",
                  }}
                  type={
                    'number'
                  }
                  disabled={
                    readOnly
                    // ? readOnly
                    // : data?.specs?.find(
                    //   (a) => a.position_desc === "DA control valve (only for NG110 and 125)"
                    // )?.value?.value === "1"
                  }
                  name={"testing_relevant_data.at_high_pressure_bc_re"}
                  value={
                    formik?.values?.testing_relevant_data?.at_high_pressure_bc_re
                  }
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.errors.testing_relevant_data?.at_high_pressure_bc_re && (
                  <p style={{ color: "red", fontSize: 12, fontWeight: "bold" }}>
                    {formik.errors.testing_relevant_data?.at_high_pressure_bc_re}

                  </p>
                )}
              </div>
            </Grid>

            <Grid item xs={3}>
              <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
                Q-Char. Reg.End
              </p>

              <div
                style={{
                  display: "flex",
                  outline: formik.errors.testing_relevant_data?.q_char_regend ? '1px solid red' : "none",
                  gap: 3,
                  alignItems: "center",
                  padding: "15px 20px",
                  backgroundColor: "rgba(255, 255, 255, 0.5)",
                  borderRadius: "15px",
                  position: "relative",
                  boxShadow:
                    "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
                }}
              >
                <input
                  style={{
                    outline: "none",
                    border: "none",
                    backgroundColor: "transparent",
                    width: "100%",
                  }}
                  type={
                    'number'
                  }
                  disabled={
                    readOnly
                    // ? readOnly
                    // : data?.specs?.find(
                    //   (a) => a.position_desc === "DA control valve (only for NG110 and 125)"
                    // )?.value?.value === "1"
                  }
                  name={"testing_relevant_data.q_char_regend"}
                  value={formik?.values?.testing_relevant_data?.q_char_regend}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.errors.testing_relevant_data?.q_char_regend && (
                  <p style={{ color: "red", fontSize: 12, fontWeight: "bold" }}>
                    {formik.errors.testing_relevant_data?.q_char_regend}

                  </p>
                )}
              </div>
            </Grid>

          </>}

        <Grid item xs={3}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>
            At working pressure
          </p>

          <div
            style={{
              display: "flex",
              outline: formik.errors.testing_relevant_data?.at_working_pressure ? '1px solid red' : "none",
              gap: 3,
              padding: "15px 20px",
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              borderRadius: "15px",
              position: "relative",
              boxShadow:
                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
            }}
          >
            <input
              style={{
                outline: "none",
                border: "none",
                backgroundColor: "transparent",
                width: "100%",
              }}
              type={
                'number'
              }
              disabled={
                readOnly

              }
              name={"testing_relevant_data.at_working_pressure"}
              value={formik?.values?.testing_relevant_data?.at_working_pressure}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.errors.testing_relevant_data?.at_working_pressure && (
              <p style={{ color: "red", fontSize: 12, fontWeight: "bold" }}>
                {formik.errors.testing_relevant_data?.at_working_pressure}

              </p>
            )}
          </div>
        </Grid>

        <Grid item xs={12}>
          <h2>SPECIAL FEATURES</h2>
        </Grid>
        <Grid item xs={3}>
          <p style={{ margin: "0 0 5px 0", fontSize: "14px" }}>Note</p>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              padding: "15px 20px",
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              borderRadius: "15px",
              position: "relative",
              boxShadow:
                "rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset",
            }}
          >
            <input
              disabled={readOnly}
              style={{
                outline: "none",
                border: "none",
                backgroundColor: "transparent",
                width: "100%",
              }}
              name={"special_features.note"}
              value={formik?.values?.special_features?.note || ""}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>
        </Grid>
      </Grid>

      {!readOnly && (
        <div style={{ padding: "30px 0" }}>
          <Box mr={mq_xs ? 0 : 1}>
            <Button
              disabled={!formik.isValid || formik.isSubmitting}
              variant="contained"
              color="inherit"
              size={mq_xs ? "small" : "medium"}
              onClick={handleClick}
            >
              Confirm and go to Summary
            </Button>
          </Box>
        </div>
      )}
    </form>
  );
};

export default A4VGV40;
